import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import './Choose.css';

const ChooseLeftDetails = ({data}) => {
    const {id, title,icon, description} =data;
    return (
        <div className="text-white left animate__animated animate__fadeInLeft animate__delay-2s">
        <div className="icons">
        <FontAwesomeIcon icon={icon} />
        </div>
            <h4 className="title">{title}</h4>
            <p>{description}</p>
        </div>
    );
};

export default ChooseLeftDetails;